import React from 'react';
import { Button } from '@mui/material';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { useError } from '../contexts/ErrorContext';

function LoginWithGoogleButton({ auth, variant, sx, onError, color }) {
  const navigate = useNavigate();
  const location = useLocation();
  const returnUrl = location.state?.returnUrl || '/dashboard';
  const { logAuthenticationError } = useError();

  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      navigate(returnUrl);
    } catch (error) {
      console.error("Error signing in with Google", error);
      
      // Log authentication error
      await logAuthenticationError(error, 'google_signin');
      
      if (onError) {
        onError("Failed to sign in with Google");
      }
    }
  };

  return (
    <Button 
      color={color || "inherit"} 
      onClick={handleLogin} 
      variant={variant}
      sx={sx}
    >
      Continue with Google
    </Button>
  );
}

export default LoginWithGoogleButton;
